import _ = require('underscore');
import angular = require('angular');
import { IPopupSettings } from '../../../../app.common/modules/common/models';
import { ClassificationCategoriesService } from '../classification-categories.service';
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { isPromise, extend } from '@uirouter/core';
import { ClassificationCategoriesBase, IClassificationCategoryListItem } from '../classification-categories-base.component';
import { EnumService } from '../../../../app.common/modules/common/services/enum.service';

class ClassificationCategoriesForStore extends ClassificationCategoriesBase {
    static $inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];

    private getTree: Function;
    private onSelect: Function;

    constructor(
        classificationCategoriesService: ClassificationCategoriesService,
        popupService: PopupService,
        $timeout: ng.ITimeoutService,
        enumService: EnumService
    ) {
        super(classificationCategoriesService, popupService, $timeout, enumService);
    }

    async getCategoriesTree() {
        return await this.getTree();
    }

    onChecked($event: Event, livecategory: IClassificationCategoryListItem) {
        if (livecategory.selected) {
            $event.preventDefault();
        }
        this.$timeout(() => {
            this.onSelect();
        }, 200);
    }
}

angular
    .module('app.retailes.common')
    .component('classificationCategoriesForStore', {
        template: require('./classification-categories-store.html'),
        controller: ClassificationCategoriesForStore,
        controllerAs: 'vm',
        bindings: {
            selectedCategories: '=',
            businessType: '<',
            singleSelect: '<',
            waiting: '<',
            errors: '=',
            externalConfirm: '@',
            changeCategory: '&',
            hideWithoutPair: '@',
            getTree: '<',
            onSelect: '<',
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/classification-categories-store/classification-categories-store.component.ts